/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Investor } from './Investor';
import {
    InvestorFromJSON,
    InvestorFromJSONTyped,
    InvestorToJSON,
} from './Investor';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface OwnershipListBonds
 */
export interface OwnershipListBonds {
    /**
     * 
     * @type {number}
     * @memberof OwnershipListBonds
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof OwnershipListBonds
     */
    readonly bondId: number;
    /**
     * 
     * @type {Date}
     * @memberof OwnershipListBonds
     */
    ownedSince: Date;
    /**
     * 
     * @type {Date}
     * @memberof OwnershipListBonds
     */
    ownedUntil?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OwnershipListBonds
     */
    bondReturned?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OwnershipListBonds
     */
    maturityDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof OwnershipListBonds
     */
    readonly orderId: number;
    /**
     * 
     * @type {Investor}
     * @memberof OwnershipListBonds
     */
    readonly investor: Investor;
}

/**
 * Check if a given object implements the OwnershipListBonds interface.
 */
export function instanceOfOwnershipListBonds(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('bondId' in value)) return false;
    if (!('ownedSince' in value)) return false;
    if (!('orderId' in value)) return false;
    if (!('investor' in value)) return false;
    return true;
}

export function OwnershipListBondsFromJSON(json: any): OwnershipListBonds {
    return OwnershipListBondsFromJSONTyped(json, false);
}

export function OwnershipListBondsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OwnershipListBonds {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'bondId': json['bond_id'],
        'ownedSince': (dayjs.tz(json['owned_since'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'ownedUntil': json['owned_until'] == null ? undefined : (dayjs.tz(json['owned_until'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'bondReturned': json['bond_returned'] == null ? undefined : (dayjs.tz(json['bond_returned'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'maturityDate': json['maturity_date'] == null ? undefined : (dayjs.tz(json['maturity_date'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'orderId': json['order_id'],
        'investor': InvestorFromJSON(json['investor']),
    };
}

export function OwnershipListBondsToJSON(value?: OwnershipListBonds | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'owned_since': (dayjs(value['ownedSince']).format('YYYY-MM-DD')),
        'owned_until': value['ownedUntil'] == null ? undefined : (dayjs(value['ownedUntil'] as any).format('YYYY-MM-DD')),
        'bond_returned': value['bondReturned'] == null ? undefined : (dayjs(value['bondReturned'] as any).format('YYYY-MM-DD')),
        'maturity_date': value['maturityDate'] == null ? undefined : (dayjs(value['maturityDate'] as any).format('YYYY-MM-DD')),
    };
}

